<template>
  <div>
    <BaseLoadingProgress2 class="base-loading-progress-first" />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <BaseNotification />
  </div>
</template>

<script lang="ts" setup>
const { $env } = useNuxtApp();
const config = useRuntimeConfig();

useHead({
  htmlAttrs: {
    lang: "ru",
  },
  link: [
    $env.isProd
      ? {
          as: "font",
          crossorigin: "anonymous",
          href: "/fonts/commissioner/medium.woff2",
          rel: "preload",
          type: "font/woff2",
        }
      : {},
    $env.isProd
      ? {
          key: "link-2",
          as: "font",
          crossorigin: "anonymous",
          href: "/fonts/commissioner/regular.woff2",
          rel: "preload",
          type: "font/woff2",
        }
      : {},
    { href: "/manifest.webmanifest", rel: "manifest" },
    { href: "/favicon.ico", rel: "icon" },
    { href: "/favicon-16x16.png", rel: "icon", sizes: "16x16", type: "image/png" },
    { href: "/favicon-32x32.png", rel: "icon", sizes: "32x32", type: "image/png" },
    { href: "/icon.svg", rel: "icon", type: "image/svg+xml" },
    { href: "/apple-touch-icon.png", rel: "apple-touch-icon" },
  ],
  meta: [
    {
      content:
        "width=device-width, minimum-scale=1, initial-scale=1, maximum-scale=1, user-scalable=0, viewport-fit=cover",
      name: "viewport",
    },
  ],
});

useSeoMeta({
  titleTemplate: (pageTitle) => {
    return pageTitle === undefined ? "MyDonut" : `${pageTitle} | MyDonut`;
  },
});

onMounted(() => {
  pageScrollComputedWidth();
  useAuthSocialError();
  useErrorForNotification();
  useTelegramInit(config);
});
</script>
